/* AJAX Pagination (delegated + scroll to section top on page click) */
(function() {
  // Always resolve the current container/section id fresh after filters re-render
  function getGridContainer() {
    return document.getElementById('ProductGridContainer');
  }
  function getSectionId() {
    const c = getGridContainer();
    return c ? c.getAttribute('data-section-id') : null;
  }

  // Optional: detect a sticky header to offset the scroll (tweak selector if needed)
  function getStickyHeaderHeight() {
    // Common Dawn selectors:
    const sticky = document.querySelector('.shopify-section-header-sticky, .header-wrapper, header[role="banner"]');
    if (!sticky) return 0;
    // If it’s fixed, subtract its height so the section isn’t hidden under it
    const styles = window.getComputedStyle(sticky);
    const isFixed = styles.position === 'fixed' || styles.position === 'sticky';
    return isFixed ? sticky.getBoundingClientRect().height : 0;
  }

  // Smoothly scroll top of the grid container into view (respects reduced motion)
  function scrollToSectionTop() {
    const container = getGridContainer();
    if (!container) return;
    const headerOffset = getStickyHeaderHeight();
    const rect = container.getBoundingClientRect();
    const absoluteTop = window.scrollY + rect.top - headerOffset - 8; // small buffer
    const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: absoluteTop < 0 ? 0 : absoluteTop,
      behavior: prefersReduce ? 'auto' : 'smooth'
    });
  }

  // Swap grid + pagination from a returned HTML string
  function swapFromHTML(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newGrid = doc.querySelector('#product-grid');
    const curGrid = document.querySelector('#product-grid');
    const newPag  = doc.querySelector('#AjaxPagination');
    const curPag  = document.querySelector('#AjaxPagination');

    if (newGrid && curGrid) {
      curGrid.innerHTML = newGrid.innerHTML;
    }

    if (curPag) {
      if (newPag) curPag.innerHTML = newPag.innerHTML;
      else curPag.remove();
    } else if (newPag) {
      const gridContainer = getGridContainer();
      const collectionRoot = gridContainer?.closest('.collection') || gridContainer || document.body;
      collectionRoot.appendChild(newPag);
    }

    document.dispatchEvent(new CustomEvent('ajax:collection:page', {
      detail: { url: window.location.href, sectionId: getSectionId() }
    }));
  }

  // Single delegated click handler: survives any DOM replacement by facets
  document.addEventListener('click', function(e) {
    const link = e.target.closest('#AjaxPagination a');
    if (!link) return;

    // Respect modifier/aux clicks
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') return;

    e.preventDefault();

    const sectionId = getSectionId();
    if (!sectionId) {
      window.location.href = link.href; // fallback
      return;
    }

    const gridContainer = getGridContainer();
    const overlay = gridContainer?.querySelector('.loading-overlay');
    if (overlay) overlay.classList.add('loading');

    const fetchUrl = new URL(link.href, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    fetch(fetchUrl.toString(), { credentials: 'same-origin' })
      .then(r => r.text())
      .then(html => {
        swapFromHTML(html);

        // Scroll to top of section after content swap (pagination click only)
        scrollToSectionTop();

        // Update the clean URL (without section_id) for history/back/refresh
        const cleanUrl = new URL(link.href, window.location.origin);
        window.history.pushState({ path: cleanUrl.toString() }, '', cleanUrl.toString());
      })
      .catch(err => {
        console.error('AJAX pagination failed, navigating normally.', err);
        window.location.href = link.href;
      })
      .finally(() => {
        if (overlay) overlay.classList.remove('loading');
      });
  }, false);

  // Handle browser back/forward — do NOT force scroll here (stays where user was)
  window.addEventListener('popstate', function() {
    const sectionId = getSectionId();
    if (!sectionId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(r => r.text())
      .then(html => swapFromHTML(html))
      .catch(err => console.error('AJAX popstate reload failed', err));
  });

  // Optional: when facets re-render, our delegated handler already works.
  document.addEventListener('facets:updated', () => {});
})();
